<template>
    <MediaWithCaption
        kind="video"
        :asset-id="content?.video"
        :content="{ text: content?.text, autoplays: content?.autoplays }"
        :containerless="containerless"
        natural-height
    />
</template>

<script lang="ts" setup>
import MediaWithCaption from "~/components/view/MediaWithCaption.vue"

defineProps({
    content: {
        type: Object
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    },
    containerless: {
        type: Boolean,
        default: false
    }
})
</script>
